module.exports = __webpack_public_path__ + "img/attendance.349b75b.png";